var mustache = {exports: {}};

export { mustache as __module };
//# sourceMappingURL=_virtual-mustache.js.map
